import { authMiddleware } from '@/middleware';

export const Partner = [
    {
        path: '/partner/users',
        name: 'partner-users-all',
        beforeEnter: [authMiddleware],
        component: () => import('@/views/partner/users'),
    },

    {
        path: '/partner/orders',
        name: 'partner-orders-all',
        beforeEnter: [authMiddleware],
        component: () => import('@/views/partner/orders'),
    },
];
